import { FormDropdownQuestion, IFormDropdownQuestion } from '../../gamma/form/formquestion/formquestion-dropdown';

export class U2000_ProvinceQuestion extends FormDropdownQuestion {
    static schema: IFormDropdownQuestion = {
        key: 'provinceId',
        label: 'lblProvince',
        maxLength: 40,
    };

    constructor(options: IFormDropdownQuestion = {}) {
        super(options);
        const schema = U2000_ProvinceQuestion.schema;

        if (String.isNullOrEmpty(this.key)) {
            this.key = schema.key;
        }
        if (String.isNullOrEmpty(this.label)) {
            this.label = schema.label;
        }
        if (this.maxLength == null) {
            this.maxLength = schema.maxLength;
        }
    }
}
